import { Checkbox, CheckboxGroup } from "@origin-digital/ods-core";
import React, { useEffect } from "react";
import { Field, FieldInputProps, useFormikContext } from "formik";
import { getFieldsDataFromAddress } from "../helpers";
import { BulkDuplicateFormValues } from "./types";

const BulkDuplicateAddressParts: React.FC = () => {
  const { values, setFieldValue } = useFormikContext<BulkDuplicateFormValues>();
  useEffect(() => {
    setFieldValue(
      "selectedAddressParts",
      Object.keys(values.addressParts).map((item) => item)
    );
  }, [values.addressParts]);

  const handleCheckboxChange = (key: string, checked: boolean) => {
    if (checked) {
      // Add to selectedAddressParts if checked
      setFieldValue("selectedAddressParts", [
        ...values.selectedAddressParts,
        key,
      ]);
      const updatedPremises = values.premises.map((premise) => ({
        ...premise,
        [key]: "",
      }));
      setFieldValue("premises", updatedPremises);
    } else {
      // Remove from selectedAddressParts if unchecked
      setFieldValue(
        "selectedAddressParts",
        values.selectedAddressParts.filter((item) => item !== key)
      );
      const updatedPremises = values.premises.map((premise) => ({
        ...premise,
        [key]: getFieldsDataFromAddress(values.addressObj, key),
      }));
      setFieldValue("premises", updatedPremises);
    }
  };

  return (
    <CheckboxGroup
      id="address-parts-checkbox-group"
      label="Which parts of the address do you need to update for each premises?"
      helperText={
        values.selectedAddressParts.length === 0
          ? "Oops, you must select at least one option. Each premises address must be unique and can't be the same as the original or any existing requests."
          : "Each premises address must be unique and can't be the same as the original or any existing requests."
      }
      error={values.selectedAddressParts.length === 0}
    >
      {Object.entries(values.addressParts).map(([key, label]) => {
        return (
          <Field
            type="checkbox"
            name="selectedAddressParts"
            value={key}
            key={key}
          >
            {({ field }: { field: FieldInputProps<string[]> }) => (
              <Checkbox
                {...field}
                id={key}
                value={key}
                label={label}
                checked={values.selectedAddressParts.includes(key)}
                onChange={(e) => handleCheckboxChange(key, e.target.checked)}
              />
            )}
          </Field>
        );
      })}
    </CheckboxGroup>
  );
};

export default BulkDuplicateAddressParts;
